import "../../styles/about.css";

import React from "react";

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  errorMessage?: string;
  onClean?: () => void;
  defaultValue?: string;
}

const TextInput: React.FC<TextInputProps> = ({
  placeholder,
  errorMessage,
  onChange,
  onClean,
  type,
  defaultValue = "",
  ...rest
}) => {
  const [value, setValue] = React.useState(defaultValue);
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [showPassword, setShowPassword] = React.useState(false);

  const handleOnChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setValue(e.target.value);
    if (onChange) onChange(e);
  };

  const handleClean = () => {
    setValue("");
    inputRef.current?.focus();
    if (onClean) {
      onClean();
    }
  };

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div className="text-input-wrapper">
        <div className="text-input">
          <input
            value={value}
            placeholder={placeholder}
            onChange={handleOnChange}
            role="presentation"
            ref={inputRef}
            type={showPassword ? "text" : type}
            {...rest}
          />
          {value && type === "password" && (
            <img
              className="input-icon"
              onClick={togglePassword}
              src={showPassword ? "/eye-close.svg" : "/eye.svg"}
            />
          )}
          {value && (
            <img
              className="input-icon"
              onClick={handleClean}
              src="/icon-x.svg"
            />
          )}
        </div>
        {errorMessage && <div className="text-input-error">{errorMessage}</div>}
      </div>
      <style jsx>{`
        .text-input-wrapper {
          width: 100%;
          .text-input {
            height: 48px;
            border: 1px solid #e7e7e7;
            position: relative;
            display: flex;
            align-items: center;
            padding: 0 16px;

            > input {
              border: none;
              flex: 1 1 auto;
              outline: none;
            }

            .input-icon {
              width: 20px;
              height: 20px;
              cursor: pointer;
              margin-left: 8px;
            }
          }

          .text-input-error {
            color: #a20000;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 100%;
            margin-top: 16px;
          }
        }
      `}</style>
    </>
  );
};

export default TextInput;
